import request from '@/utils/request'
import chaosiRequest from '@/utils/chaosiRequest'
import qs from 'qs'

// 参数加密默认密钥
const DEFAULT_KEY = '4FC724FC8CB0D6CCBB04F50C18818F0B'
function param (data, key = DEFAULT_KEY) { // 整理参数的格式
  data.memberId = global.memberId
  data.channelSign = global.channelSign
  data.timestamp = Math.ceil(new Date().getTime() / 1000)
  var newkey = Object.keys(data).sort()
  var newArr = [] // 创建一个新的对象，用于存放排好序的键值对
  for (var i = 0; i < newkey.length; i++) {
    // 遍历newkey数组
    if (data[newkey[i]]) {
      var text = newkey[i] + '=' + data[newkey[i]]
      newArr.push(text)
    }
  }
  newArr.push(`key=${key}`)
  var newObj = SparkMD5.hash(newArr.join('&'))
  data.sign = newObj
  return qs.stringify(data, {arrayFormat: 'brackets'})
}
var hrefStr = window.location.host == 'm.syrjia.com' ? 'https://mobile.syrjia.com' : ''
export function post (url, params) {
  return request({
    url: hrefStr + '/syrjiaPtApi' + url,
    method: 'POST',
    data: param(params)
  })
}
export function postPay (url, params) {
  return request({
    // url: 'https://test-syrjia.syrjia.cn/syrjiaPtApi' + url,
    url: hrefStr + '/payCenterServer' + url,
    method: 'POST',
    data: param(params)
  })
}
export function get (url, params) {
  return request({
    url:  hrefStr + '/syrjiaPtApi' + url,
    method: 'get',
    data: param(params)
  })
}

export function upload (params) {
  let http = process.env.NODE_ENV == 'development' ? '' : hrefStr // 'https://file.syrjia.com'
  return request({
    url: http + '/FileService/thumUpload',
    method: 'POST',
    data: param(params)
  })
}
export function postForm (url, params) {
  return request({
    url: hrefStr + '/syrjiaPtApi' + url,
    method: 'POST',
    data: params
  })
}

// 知识圈参数加密密钥
const KNOWLEDGE_KEY = 'A542E9B744BEDCFD874129AB0F98C4FF'
export function postKnowledge (url, params) {
  return request({
    // url: hrefStr + '/syrjiaPtApi' + url,
    url: hrefStr + '/knowledgeApi' + url,
    method: 'POST',
    data: param(params, KNOWLEDGE_KEY)
  })
}

export function chaosiPost(url,params){
  console.log(params)
  return chaosiRequest({
    url: url,
    method: 'POST',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/utils/http.js